export const PROVIDER_CREDENTIAL_JSON_ACCEPT = ".json,application/json"
export const PROVIDER_CREDENTIAL_JSON_MAX_BYTES = 1024 * 1024

type ProviderCredentialJSONFile = Pick<File, "name" | "size" | "type" | "text">

function providerCredentialFileLooksLikeJSON(file: Pick<ProviderCredentialJSONFile, "name" | "type">) {
  const name = String(file.name || "").trim().toLowerCase()
  const mediaType = String(file.type || "").split(";", 1)[0]!.trim().toLowerCase()
  return name.endsWith(".json") ||
    mediaType === "application/json" ||
    mediaType === "text/json" ||
    mediaType.endsWith("+json")
}

export async function readProviderCredentialJSONFile(file: ProviderCredentialJSONFile) {
  if (file.size <= 0) throw new Error("Credential JSON file is empty.")
  if (file.size > PROVIDER_CREDENTIAL_JSON_MAX_BYTES) {
    throw new Error("Credential JSON file must be 1 MB or smaller.")
  }
  if (!providerCredentialFileLooksLikeJSON(file)) {
    throw new Error("Choose a .json credential file.")
  }

  let contents = ""
  try {
    contents = (await file.text()).trim()
  } catch {
    throw new Error("Could not read that credential file. Try again.")
  }
  if (!contents) throw new Error("Credential JSON file is empty.")

  let parsed: unknown
  try {
    parsed = JSON.parse(contents)
  } catch {
    throw new Error("Credential file does not contain valid JSON.")
  }
  if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
    throw new Error("Credential JSON must contain an object.")
  }
  return contents
}
